import moment from "moment";
import { formatMoney } from "../../../features/utils/formatMoney";
import {
  invoiceSelectedServices,
  invoiceServiceFeeCalculation,
  invoiceTaxCalculation,
} from "../../../controllers/invoiceController";
import { getCurrencySymbol } from "../../../features/utils/countires";

export function templateInvoiceOrderData(data) {
  let nameArray = [];
  if (data?.customer?.firstName)
    nameArray = [...nameArray, data?.customer?.firstName];
  if (data?.customer?.middleName)
    nameArray = [...nameArray, data?.customer?.middleName];
  if (data?.customer?.lastName)
    nameArray = [...nameArray, data?.customer?.lastName];

  const services = invoiceSelectedServices({
    data,
    services: [],
    fetched: true,
  });

  const tax = invoiceTaxCalculation({ services, data })?.amount;
  const serviceFee = invoiceServiceFeeCalculation({ services, data })?.amount;

  const totalAmount =
    services?.reduce((acc, current) => {
      return acc + (current?.unitPrice || 0) * (current?.quantity || 0);
    }, 0) +
    tax +
    serviceFee;
  const currency = services?.at(0)?.currency;
  const total = formatMoney(
    totalAmount,
    currency ? getCurrencySymbol(currency) : undefined
  );
  return [
    {
      elements: [
        {
          type: "title",
          value: "Invoice NO",
        },
        {
          type: "text",
          value: data?.invoiceNo,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Billed To",
        },
        {
          type: "text",
          value: nameArray?.join(" "),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Issued on",
        },
        {
          type: "text",
          value: moment(data?.createdAt)?.format("MMMM DD, YYYY"),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Payment Due",
        },
        {
          type: "text",
          value: moment(data?.paymentDue)?.format("MMMM DD, YYYY"),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    // {
    //   elements: [
    //     {
    //       type: "title",
    //       value: "Passengers",
    //     },
    //     {
    //       type: "text",
    //       value: "1",
    //     },
    //   ],
    //   value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
    //   width: "md:w-[15%]",
    // },
    {
      elements: [
        {
          type: "title",
          value: "Price",
        },
        {
          type: "text",
          value: total,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Total",
        },
        {
          type: "text",
          value: total,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Status",
        },
        {
          type: "status",
          value: data?.status,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
  ];
}

export function templateInvoiceServicesData(data) {
  return [
    {
      elements: [
        {
          type: "title",
          value: "Name",
        },
        {
          type: "text",
          value: data?.title,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Description",
        },
        {
          type: "text",
          value: data?.description?.join("\n"),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[35%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "SKU",
        },
        {
          type: "text",
          value: "",
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },

    {
      elements: [
        {
          type: "title",
          value: "Price",
        },
        {
          type: "text",
          value: formatMoney(
            data?.unitPrice || data?.defaultUnitPrice,
            data?.currency === "USD" ? "$" : undefined
          ),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Date created",
        },
        {
          type: "text",
          value: moment(data?.createdAt)?.format("MMMM DD, YYYY"),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
  ];
}

export function templateInvoiceCustomerData(data) {
  return [
    {
      elements: [
        {
          type: "title",
          value: "Full name",
        },
        {
          type: "text",
          value:
            data?.firstName + " " + data?.middleName + " " + data?.lastName,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Email",
        },
        {
          type: "text",
          value: data?.email,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Address",
        },
        {
          type: "text",
          value: data?.address,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },

    {
      elements: [
        {
          type: "title",
          value: "Phone number",
        },
        {
          type: "text",
          value: data?.phone,
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Date created",
        },
        {
          type: "text",
          value: moment(data?.createdAt)?.format("MMMM DD, YYYY"),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
  ];
}
